import { Link as RouterLink, LinkProps as RouterLinkProps } from 'react-router-dom';
import { forwardRef } from 'react';

export const CustomLink = forwardRef<HTMLAnchorElement, Omit<RouterLinkProps, 'to'> & { href: RouterLinkProps['to'] }>((props, ref) => {
    const { href, ...otherProps } = props;
    // mapping "href" prop (Material UI) to the "to" prop (react-router-dom)
    return <RouterLink ref={ref} to={href} role={undefined} {...otherProps} />;
});